import React, { useState, useEffect } from 'react'
import { Grid, Typography, Checkbox, TextField } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { callAPI,getPharmaCoreAPIPrefix } from 'api/ApiUtils';
import { getPhpackagingmaterialInfoByFormidAPI } from 'components/phpackagingmaterial/PhpackagingmaterialAPI';
import { addPhpackagingmaterialObj, deletePhpackagingmaterialObj } from 'store/slice/PharmaSlice';

export default function ManagePackagingMaterial() {
  const dispatch = useDispatch();
  const { phpackagingmaterialList } = useSelector((state) => state.pharmaslice);
  const [packagingMaterial, setPackagingMaterial] = useState(phpackagingmaterialList);
  const [selectedIds, setSelectedIds] = useState([]);
  const {phproductformObj} = useSelector((state) => state.pharmaslice.phproductformDashboard);
  const [packagingMaterialByFormId, setPackagingMaterialByFormId] = useState([]);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    getPhpackagingmaterialInfoByFormidAPI(phproductformObj.id, setPackagingMaterialByFormId, ()=>{});
  }, [phproductformObj.id]);

  // Set selectedIds based on packagingMaterialByFormId when it changes
  useEffect(() => {
    if (packagingMaterialByFormId && packagingMaterialByFormId.length > 0) {
      setSelectedIds(packagingMaterialByFormId.map(item => item.id));
    } else {
      setSelectedIds([]);
    }
  }, [packagingMaterialByFormId]);

  const addPackagingMaterial = (item) => {
    callAPI(
      getPharmaCoreAPIPrefix() + '/phpackagingmaterial',
      'POST',
      {
        formid: phproductformObj?.id,
        formname: phproductformObj?.title,
        title: item.title,
      },
      (response) => {
        // Success callback
        console.log("Packaging material added successfully:", response);
        dispatch(addPhpackagingmaterialObj(response));
      },
      (error) => {
        // Failure callback
        console.error("Failed to add packaging material:", error);
      }
    );
  }

  const deletePackagingMaterial = (item) => {
    callAPI(
      getPharmaCoreAPIPrefix() + '/phpackagingmaterial/' + item.id,
      'DELETE',
      {},
      (response) => {
        // Success callback
        dispatch(deletePhpackagingmaterialObj(item.id));
        console.log("Packaging material deleted successfully:", response);
      },
      (error) => {
        // Failure callback
        console.error("Failed to delete packaging material:", error);
      }
    );
  }

  const handleSelect = (item) => {
    const isSelected = selectedIds.includes(item.id);
    let newSelectedIds;
    if (isSelected) {
      // Deselect
      newSelectedIds = selectedIds.filter((id) => id !== item.id);
      deletePackagingMaterial(item); // Call only when deselecting
    } else {
      // Select
      newSelectedIds = [...selectedIds, item.id];
      addPackagingMaterial(item); // Call only when selecting
    }
    setSelectedIds(newSelectedIds);
  };

  // Filtered and sorted packaging material list
  const filteredPackagingMaterial = packagingMaterial
    ? [...packagingMaterial]
        .filter(item => item.title.toLowerCase().includes(filter.toLowerCase()))
        .sort((a, b) => a.title.localeCompare(b.title))
    : [];

  return (
    <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", flexWrap: "wrap" }}>
      <Grid item xs={12} lg={12} sx={{ mb: .5 }}>
        <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
         Packaging Material List
        </Typography>
      </Grid>
      <Grid item xs={12} lg={12} sx={{ mb: 2,mt:2 }}>
        <TextField
          label="Filter Packaging Material"
          variant="outlined"
          size="small"
          value={filter}
          onChange={e => setFilter(e.target.value)}
          sx={{ width: '100%'}}
        />
      </Grid>
      <Grid container direction="row" sx={{backgroundColor: 'primary.lighter', padding: 1, borderRadius: 1, mb: 2}}>
        {filteredPackagingMaterial.map((item) => (
          <Grid
            item
            lg={3}
            xs={6}
            md={3}
            sm={4}
            key={item.id}
            sx={{
              display: 'flex',
              alignItems: 'center',
              mr: 2,
              mb: 1,
              cursor: 'pointer',
              backgroundColor: selectedIds.includes(item.id) ? 'primary.lighter' : 'transparent',
              borderRadius: 1,
              px: 1,
            }}
          >
            <Checkbox
              checked={selectedIds.includes(item.id)}
              onChange={() => handleSelect(item)}
              value={item.id}
              color="primary"
              sx={{ mr: 1, }}
            />
            <Typography variant="h6" sx={{ padding: 1, whiteSpace: "nowrap" }}>
              {item.title}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}